(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["index-mixmatch"] && !window.DesignMode) return;
  try {
    

$('.swatch-link').click(function(event){
	event.preventDefault();
	var targetId = $(this).data('target-id');
	var target = document.querySelector(".mixmatch-collection .mixmatch-item-" + targetId);
	var parent = target.closest('.mixmatch-collection');
	parent.scrollLeft = target.offsetLeft;
//	target.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
});

// $(function() {
	
// //top clone
//   // Clone the content
//   var $contentTop = $('.mixmatch-collection-top');
//   var $cloneTop = $('.clone-top').html($contentTop.html());
  
//   // Performance scrolling
//   var contentTop = $contentTop.get(0);
//   var cloneTop = $cloneTop.get(0);
//   contentTop.onscroll = function() {
// 	$('.clone-top').css("left", -1 * contentTop.scrollLeft + "px");
//   };

// // bottom clone
//   // Clone the content
//   var $contentBottom = $('.mixmatch-collection-bottom');
//   var $cloneBottom = $('.clone-bottom').html($contentBottom.html());
  
//   // Performance scrolling
//   var contentBottom = $contentBottom.get(0);
//   var cloneBottom = $cloneBottom.get(0);
//   contentBottom.onscroll = function() {
// 	$('.clone-bottom').css("left", -1 * contentBottom.scrollLeft + "px");
//   };
// });

$('.next-top').click(function(){
    const content = document.querySelector('.mixmatch-collection-top');
    content.scroll(content.scrollLeft + content.offsetWidth, 0);
})

$('.prev-top').click(function(){
	const content = document.querySelector('.mixmatch-collection-top');
    content.scroll(content.scrollLeft - content.offsetWidth, 0);
})

$('.next-bottom').click(function(){
    const content = document.querySelector('.mixmatch-collection-bottom');
    content.scroll(content.scrollLeft + content.offsetWidth, 0);
})

$('.prev-bottom').click(function(){
	const content = document.querySelector('.mixmatch-collection-bottom');
    content.scroll(content.scrollLeft - content.offsetWidth, 0);
})


$('.item-images, .turnaround').click(function(){
	$('.image-front').toggleClass('hide');
})


  } catch(e) { console.error(e); }
})();

})();
